// extracted by mini-css-extract-plugin
export var headerCell = "_1n-1";
export var loadingStateCell = "_1n-4";
export var rowWrapper = "_1n-3";
export var standaloneTable = "_1n-5";
export var table = "_1n-0";
export var white = "_1n-2";